import React from 'react';
import { getMessage } from '@tcc/i18n';
import { useSelector } from 'react-redux';
import { PlantingProductsGroup } from '../types';

import styles from '../../../../components/cards/cardAndPreview/cardAndPreview.css';
import { getPlantingArdDataFeatureSelector } from '../../../../selectors';

export const HybridMetrics = ({ id, name, events}: PlantingProductsGroup) => {
  const isArdDataEnabled = useSelector(getPlantingArdDataFeatureSelector)
  const areaMessage = getMessage('card.planting.planted').toLowerCase();

  const eventsSorted = events.sort((a, b) =>
    new Date(a.plantingDate).getTime() - new Date(b.plantingDate).getTime());

  return (
    <div className={styles.hybridItem} key={`hybrid-${id}`} data-test-id={`hybrid-${id}`}>
    <div className={styles.value} data-test-id={`hybrid-name-${isArdDataEnabled ? id : name}`}>{name}</div>
      { eventsSorted.map(({locPlantedArea, plantingDate}, index) => (
        <h3 data-test-id={`hybrid-value-${id}-${index}`} key={`hybrid-value-${id}-${plantingDate}`}>
          {`${locPlantedArea.q} ${locPlantedArea.u} ${areaMessage} - ${plantingDate}`}
        </h3>
      ))}
    </div>
  )
}
